// /* ============================================================
//    LB-CART.JS — Panier Shopify · Dawn-style async optimiste
   
//    Comportement :
//    - Clic +/− → UI mise à jour IMMÉDIATEMENT (optimiste)
//    - Accumulation des clics sans blocage
//    - Un seul appel API après 500ms de silence (debounce)
//    - Loader sur les boutons +/− UNIQUEMENT pendant l'appel réseau
//    - Revert UI si erreur serveur
//    - Toast si stock dépassé (détecté côté client ET côté serveur)
//    - Queue séquentielle → jamais deux appels en parallèle
//    ============================================================ */
// 'use strict';

// /* ── Helpers ─────────────────────────────────────────────── */
// function formatMoney(cents) {
//   if (cents == null) return '';
//   return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
// }

// /* ── Toast ───────────────────────────────────────────────── */
// const Toast = {
//   wrap: null,
//   init()  { this.wrap = document.getElementById('toast-wrap'); },
//   show(msg, type = 'info', ms = 3500) {
//     if (!this.wrap) return;
//     const icons = { ok: '✓', err: '✕', info: 'ℹ' };
//     const t = document.createElement('div');
//     t.className = `toast toast--${type}`;
//     t.innerHTML = `<span class="toast__ico">${icons[type] || icons.info}</span><span>${msg}</span><span class="toast__x">×</span>`;
//     t.querySelector('.toast__x').onclick = () => this._remove(t);
//     this.wrap.appendChild(t);
//     requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('show')));
//     setTimeout(() => this._remove(t), ms);
//   },
//   _remove(t) { t.classList.remove('show'); setTimeout(() => t.remove(), 420); }
// };

// /* ══════════════════════════════════════════════════════════
//    QtyController — Gestion optimiste d'un article
   
//    Chaque article (par `key`) a son propre controller.
//    Il maintient :
//      - displayQty  : quantité affichée (optimiste, mise à jour immédiate)
//      - confirmedQty: dernière quantité confirmée par Shopify
//      - pendingQty  : cible du prochain appel API (null si rien en attente)
//    ══════════════════════════════════════════════════════════ */
// class QtyController {
//   constructor({ key, initialQty, maxQty, qtyEl, minusBtn, plusBtn, onCommit, onRemove }) {
//     this.key          = key;
//     this.displayQty   = initialQty;
//     this.confirmedQty = initialQty;
//     this.pendingQty   = null;
//     this.maxQty       = maxQty;
//     this.qtyEl        = qtyEl;     // div wrapper .cart-qty__val / .cd-qty__val
//     this.minusBtn     = minusBtn;
//     this.plusBtn      = plusBtn;
//     this.onCommit     = onCommit;  // async fn(key, qty) → CartEngine._doChange
//     this.onRemove     = onRemove;  // fn() appelée quand qty → 0
//     this._timer       = null;
//     this._loading     = false;
//   }

//   /* Appelé à chaque clic +/− */
//   step(direction) {
//     const next = direction === 'plus'
//       ? Math.min(this.displayQty + 1, this.maxQty)
//       : Math.max(this.displayQty - 1, 0);

//     // Vérif stock côté client
//     if (direction === 'plus' && this.displayQty >= this.maxQty) {
//       Toast.show(`Maximum disponible : ${this.maxQty}`, 'err');
//       this._shakeBtn(this.plusBtn);
//       return;
//     }

//     // ① Mise à jour UI immédiate (optimiste)
//     this.displayQty = next;
//     this._renderQty(next);
//     this._updateBtnStates();

//     // ② Planifie l'appel API (debounce 500ms)
//     this.pendingQty = next;
//     this._scheduleCommit();
//   }

//   /* Force une quantité précise (ex. : depuis un input) */
//   setTo(qty) {
//     const clamped = Math.max(0, Math.min(qty, this.maxQty));
//     if (clamped > qty) Toast.show(`Maximum disponible : ${this.maxQty}`, 'err');
//     this.displayQty = clamped;
//     this.pendingQty = clamped;
//     this._renderQty(clamped);
//     this._updateBtnStates();
//     this._scheduleCommit();
//   }

//   /* ── Internals ── */

//   _scheduleCommit() {
//     clearTimeout(this._timer);
//     this._timer = setTimeout(() => this._commit(), 500);
//   }

//   async _commit() {
//     if (this.pendingQty === null) return;
//     const qty = this.pendingQty;
//     this.pendingQty = null;

//     // Affiche loader sur les boutons pendant l'appel réseau
//     this._setLoading(true);

//     try {
//       await this.onCommit(this.key, qty);
//       // onCommit met à jour this.confirmedQty via updateConfirmed()
//     } catch (e) {
//       // Revert en cas d'erreur réseau pure (les erreurs Shopify sont
//       // gérées dans Cart._doChange qui appellera revert() directement)
//       console.error('[QtyController] commit error', e);
//     } finally {
//       this._setLoading(false);
//     }
//   }

//   /* Appelé par Cart après succès API */
//   updateConfirmed(newQty, newMaxQty) {
//     this.confirmedQty = newQty;
//     if (newMaxQty !== undefined) this.maxQty = newMaxQty;
//     // Si aucun pending en vol, on sync l'affichage avec le serveur
//     if (this.pendingQty === null && !this._loading) {
//       this.displayQty = newQty;
//       this._renderQty(newQty);
//       this._updateBtnStates();
//     }
//   }

//   /* Appelé par Cart en cas d'erreur → revert à l'état confirmé */
//   revert() {
//     this.displayQty = this.confirmedQty;
//     this.pendingQty = null;
//     clearTimeout(this._timer);
//     this._renderQty(this.confirmedQty);
//     this._updateBtnStates();
//   }

//   _renderQty(n) {
//     if (!this.qtyEl) return;
//     // Cherche le span de nombre dans .qty-num ou .qn
//     const span = this.qtyEl.querySelector('.qty-num, .qn');
//     if (span) span.textContent = n;
//     this.qtyEl.dataset.qty = n;
//   }

//   _updateBtnStates() {
//     // Ne désactive les boutons que pour les cas extrêmes (stock 0 / min 0)
//     // On NE désactive PAS pendant le chargement → l'utilisateur peut accumuler
//     if (this.plusBtn)  this.plusBtn.disabled  = this.displayQty >= this.maxQty;
//     if (this.minusBtn) this.minusBtn.disabled = this.displayQty <= 0;
//   }

//   _setLoading(on) {
//     this._loading = on;
//     // Petit loader visuel sur les deux boutons (classe CSS)
//     [this.minusBtn, this.plusBtn].forEach(btn => {
//       if (!btn) return;
//       btn.classList.toggle('btn--loading', on);
//       // On n'utilise PAS disabled ici pour garder l'accumulation possible
//     });
//     // Indicateur sur le wrapper de quantité
//     this.qtyEl?.classList.toggle('qty--syncing', on);
//   }

//   _shakeBtn(btn) {
//     if (!btn) return;
//     btn.classList.remove('shake');
//     void btn.offsetWidth;
//     btn.classList.add('shake');
//     setTimeout(() => btn.classList.remove('shake'), 400);
//   }
// }

// /* ══════════════════════════════════════════════════════════
//    Cart Engine
//    ══════════════════════════════════════════════════════════ */
// const Cart = {
//   data:        null,
//   _queue:      Promise.resolve(),
//   _controllers: new Map(), // key → QtyController

//   /* ── Init ──────────────────────────────────────────────── */
//   async init() {
//     this.data = await this._fetch();
//     this._refreshAllUI();
//     this._bindForms();
//   },

//   /* ── Fetch ─────────────────────────────────────────────── */
//   async _fetch() {
//     const r = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
//     const d = await r.json();
//     this.data = d;
//     return d;
//   },

//   /* ── Add to cart ───────────────────────────────────────── */
//   async addItem(variantId, qty = 1, btnEl = null) {
//     if (btnEl) { btnEl.classList.add('loading'); btnEl.disabled = true; }
//     try {
//       const r = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: qty })
//       });
//       const d = await r.json();
//       if (!r.ok) {
//         // Shopify renvoie l'erreur stock ici
//         const msg = d.description || d.message || '';
//         if (/stock|available|quantity/i.test(msg)) {
//           Toast.show('Quantité demandée non disponible en stock.', 'err');
//         } else {
//           Toast.show(msg || 'Impossible d\'ajouter au panier.', 'err');
//         }
//         return null;
//       }
//       Toast.show('Produit ajouté au panier ✓', 'ok');
//       await this._fetch();
//       this._refreshAllUI();
//       if (window.LB?.CartDrawer) CartDrawer.open();
//       return d;
//     } catch (e) {
//       Toast.show('Erreur réseau. Réessayez.', 'err');
//       return null;
//     } finally {
//       if (btnEl) { btnEl.classList.remove('loading'); btnEl.disabled = false; }
//     }
//   },

//   /* ── Enregistre / récupère un QtyController pour un item ── */
//   getController(key, { initialQty, maxQty, qtyEl, minusBtn, plusBtn }) {
//     if (!this._controllers.has(key)) {
//       const ctrl = new QtyController({
//         key, initialQty, maxQty, qtyEl, minusBtn, plusBtn,
//         onCommit:  (k, q) => this._enqueue(k, q, qtyEl),
//         onRemove:  ()     => this._animateRemove(qtyEl)
//       });
//       this._controllers.set(key, ctrl);
//     }
//     return this._controllers.get(key);
//   },

//   /* ── Enfile l'appel API dans la queue séquentielle ─────── */
//   _enqueue(key, qty, qtyEl) {
//     return new Promise((resolve, reject) => {
//       this._queue = this._queue
//         .then(() => this._doChange(key, qty, qtyEl))
//         .then(resolve)
//         .catch(reject);
//     });
//   },

//   /* ── Appel API effectif ─────────────────────────────────── */
//   async _doChange(key, qty, qtyEl) {
//     try {
//       const r = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: key, quantity: qty })
//       });
//       const d = await r.json();

//       if (!r.ok) {
//         // Shopify renvoie la vraie erreur (ex. stock insuffisant)
//         const msg = d.description || d.message || '';
//         const ctrl = this._controllers.get(key);

//         // Détecte erreur stock
//         if (/stock|available|quantity/i.test(msg)) {
//           // Trouve le stock réel depuis la réponse si dispo
//           const realMax = d.remaining_qty ?? ctrl?.confirmedQty ?? 0;
//           Toast.show(
//             realMax > 0
//               ? `Stock insuffisant — maximum disponible : ${realMax}`
//               : 'Ce produit n\'est plus disponible.',
//             'err'
//           );
//         } else {
//           Toast.show(msg || 'Erreur mise à jour panier.', 'err');
//         }

//         // Revert UI
//         ctrl?.revert();
//         await this._fetch();
//         this._refreshAllUI();
//         return;
//       }

//       this.data = d;

//       // Met à jour le controller avec les données confirmées
//       const ctrl = this._controllers.get(key);
//       if (ctrl) {
//         const serverItem = d.items.find(i => i.key === key);
//         if (serverItem) {
//           ctrl.updateConfirmed(
//             serverItem.quantity,
//             serverItem.variant?.inventory_quantity || 99
//           );
//         } else if (qty === 0) {
//           // Article supprimé → animation retrait
//           this._animateRemove(qtyEl);
//         }
//       }

//       this._refreshAllUI();

//     } catch (e) {
//       Toast.show('Erreur réseau.', 'err');
//       this._controllers.get(key)?.revert();
//       await this._fetch();
//       this._refreshAllUI();
//     }
//   },

//   /* ── Animation suppression ligne ───────────────────────── */
//   _animateRemove(qtyEl) {
//     const row = qtyEl?.closest('[data-cart-item], [data-cd-item]');
//     if (!row) return;
//     row.style.transition = 'opacity .3s ease, max-height .4s ease, margin .4s ease';
//     row.style.overflow   = 'hidden';
//     row.style.maxHeight  = row.offsetHeight + 'px';
//     row.style.opacity    = '0';
//     requestAnimationFrame(() => {
//       row.style.maxHeight  = '0';
//       row.style.marginTop  = '0';
//       row.style.marginBottom = '0';
//     });
//     setTimeout(() => row.remove(), 450);
//   },

//   /* ── Refresh global UI ──────────────────────────────────── */
//   _refreshAllUI() {
//     const c = this.data;
//     if (!c) return;
//     this._updateCount(c.item_count);
//     this._updateSubtotals(c.total_price);
//     this._updateShippingBar(c.total_price);
//     if (typeof CartDrawer !== 'undefined') CartDrawer.renderItems(c);
//     if (typeof CartPage   !== 'undefined') CartPage.renderItems(c);
//   },

//   _updateCount(n) {
//     document.querySelectorAll('[data-cart-count]').forEach(el => {
//       el.textContent = n;
//       el.classList.toggle('d-none', n === 0);
//       el.classList.remove('bump');
//       void el.offsetWidth;
//       if (n > 0) el.classList.add('bump');
//     });
//   },

//   _updateSubtotals(cents) {
//     document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
//       el.textContent = formatMoney(cents);
//     });
//   },

//   _updateShippingBar(total) {
//     const thresh    = window.LB?.freeShipThreshold || 4900;
//     const pct       = Math.min(100, Math.round((total / thresh) * 100));
//     const remaining = Math.max(0, thresh - total);
//     document.querySelectorAll('[data-ship-fill]').forEach(el => el.style.width = pct + '%');
//     document.querySelectorAll('[data-ship-txt]').forEach(el => {
//       el.innerHTML = pct >= 100
//         ? '🎉 Livraison offerte !'
//         : `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte`;
//     });
//   },

//   /* ── Bind ATC forms ─────────────────────────────────────── */
//   _bindForms() {
//     document.querySelectorAll('[data-prod-form]').forEach(form => {
//       form.addEventListener('submit', async e => {
//         e.preventDefault();
//         const variantId = parseInt(form.querySelector('[name="id"]')?.value);
//         const qty       = parseInt(form.querySelector('[data-qty-input]')?.value || '1');
//         const btn       = form.querySelector('[data-atc-btn]');
//         if (!variantId) return;
//         await Cart.addItem(variantId, qty, btn);
//       });
//     });
//   }
// };

// /* ══════════════════════════════════════════════════════════
//    CartPage — Page /cart
//    ══════════════════════════════════════════════════════════ */
// const CartPage = {
//   el: null,

//   init() {
//     this.el = document.querySelector('[data-cart-page]');
//     if (!this.el) return;
//     this._bindEvents();
//   },

//   _bindEvents() {
//     this.el.addEventListener('click', e => {
//       // +/-
//       const qtyBtn = e.target.closest('[data-qty-btn]');
//       if (qtyBtn) {
//         const row = qtyBtn.closest('[data-cart-item]');
//         if (!row) return;
//         const ctrl = this._getCtrl(row);
//         if (ctrl) ctrl.step(qtyBtn.dataset.qtyBtn);
//         return;
//       }
//       // Supprimer
//       const rmBtn = e.target.closest('[data-remove-item]');
//       if (rmBtn) {
//         const row = rmBtn.closest('[data-cart-item]');
//         if (!row) return;
//         const ctrl = this._getCtrl(row);
//         if (ctrl) ctrl.setTo(0);
//       }
//     });
//   },

//   _getCtrl(row) {
//     const key      = row.dataset.key;
//     const maxQty   = parseInt(row.dataset.maxQty || '99');
//     const qtyEl    = row.querySelector('[data-qty-val]');
//     const minusBtn = row.querySelector('[data-qty-btn="minus"]');
//     const plusBtn  = row.querySelector('[data-qty-btn="plus"]');
//     const initQty  = parseInt(qtyEl?.dataset.qty || '1');
//     if (!key) return null;
//     return Cart.getController(key, { initialQty: initQty, maxQty, qtyEl, minusBtn, plusBtn });
//   },

//   renderItems(cart) {
//     if (!this.el) return;
//     cart.items.forEach(item => {
//       const row = this.el.querySelector(`[data-cart-item][data-key="${item.key}"]`);
//       if (!row) return;
//       // Prix de ligne
//       const priceEl = row.querySelector('[data-line-price]');
//       if (priceEl) priceEl.textContent = formatMoney(item.line_price);
//       // Sync controller si pas de pending
//       const ctrl = Cart._controllers.get(item.key);
//       if (ctrl) ctrl.updateConfirmed(item.quantity, item.variant?.inventory_quantity || 99);
//     });
//     // Total
//     document.querySelectorAll('[data-cart-total]').forEach(el => {
//       el.textContent = formatMoney(cart.total_price);
//     });
//   }
// };

// /* ── Init ────────────────────────────────────────────────── */
// document.addEventListener('DOMContentLoaded', () => {
//   Toast.init();
//   Cart.init();
//   CartPage.init();
// });

// window.LB = window.LB || {};
// window.LB.Cart        = Cart;
// window.LB.Toast       = Toast;
// window.LB.formatMoney = formatMoney;

/* ============================================================
   LB-CART.JS — Panier Shopify · Dawn-style async optimiste
   PATCH : _bindForms() ne bind plus les formulaires produit
           déjà gérés par lb-product.js (évite le double-submit
           et le re-disable du bouton ATC)
   ============================================================ */
'use strict';

/* ── Helpers ─────────────────────────────────────────────── */
function formatMoney(cents) {
  if (cents == null) return '';
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

/* ── Toast ───────────────────────────────────────────────── */
const Toast = {
  wrap: null,
  init()  { this.wrap = document.getElementById('toast-wrap'); },
  show(msg, type = 'info', ms = 3500) {
    if (!this.wrap) return;
    const icons = { ok: '✓', err: '✕', info: 'ℹ' };
    const t = document.createElement('div');
    t.className = `toast toast--${type}`;
    t.innerHTML = `<span class="toast__ico">${icons[type] || icons.info}</span><span>${msg}</span><span class="toast__x">×</span>`;
    t.querySelector('.toast__x').onclick = () => this._remove(t);
    this.wrap.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('show')));
    setTimeout(() => this._remove(t), ms);
  },
  _remove(t) { t.classList.remove('show'); setTimeout(() => t.remove(), 420); }
};

/* ══════════════════════════════════════════════════════════
   QtyController
   ══════════════════════════════════════════════════════════ */
class QtyController {
  constructor({ key, initialQty, maxQty, qtyEl, minusBtn, plusBtn, onCommit, onRemove }) {
    this.key          = key;
    this.displayQty   = initialQty;
    this.confirmedQty = initialQty;
    this.pendingQty   = null;
    this.maxQty       = maxQty;
    this.qtyEl        = qtyEl;
    this.minusBtn     = minusBtn;
    this.plusBtn      = plusBtn;
    this.onCommit     = onCommit;
    this.onRemove     = onRemove;
    this._timer       = null;
    this._loading     = false;
  }

  step(direction) {
    const next = direction === 'plus'
      ? Math.min(this.displayQty + 1, this.maxQty)
      : Math.max(this.displayQty - 1, 0);

    if (direction === 'plus' && this.displayQty >= this.maxQty) {
      Toast.show(`Maximum disponible : ${this.maxQty}`, 'err');
      this._shakeBtn(this.plusBtn);
      return;
    }

    this.displayQty = next;
    this._renderQty(next);
    this._updateBtnStates();
    this.pendingQty = next;
    this._scheduleCommit();
  }

  setTo(qty) {
    const clamped = Math.max(0, Math.min(qty, this.maxQty));
    if (clamped > qty) Toast.show(`Maximum disponible : ${this.maxQty}`, 'err');
    this.displayQty = clamped;
    this.pendingQty = clamped;
    this._renderQty(clamped);
    this._updateBtnStates();
    this._scheduleCommit();
  }

  _scheduleCommit() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this._commit(), 500);
  }

  async _commit() {
    if (this.pendingQty === null) return;
    const qty = this.pendingQty;
    this.pendingQty = null;
    this._setLoading(true);
    try {
      await this.onCommit(this.key, qty);
    } catch (e) {
      console.error('[QtyController] commit error', e);
    } finally {
      this._setLoading(false);
    }
  }

  updateConfirmed(newQty, newMaxQty) {
    this.confirmedQty = newQty;
    if (newMaxQty !== undefined) this.maxQty = newMaxQty;
    if (this.pendingQty === null && !this._loading) {
      this.displayQty = newQty;
      this._renderQty(newQty);
      this._updateBtnStates();
    }
  }

  revert() {
    this.displayQty = this.confirmedQty;
    this.pendingQty = null;
    clearTimeout(this._timer);
    this._renderQty(this.confirmedQty);
    this._updateBtnStates();
  }

  _renderQty(n) {
    if (!this.qtyEl) return;
    const span = this.qtyEl.querySelector('.qty-num, .qn');
    if (span) span.textContent = n;
    this.qtyEl.dataset.qty = n;
  }

  _updateBtnStates() {
    if (this.plusBtn)  this.plusBtn.disabled  = this.displayQty >= this.maxQty;
    if (this.minusBtn) this.minusBtn.disabled = this.displayQty <= 0;
  }

  _setLoading(on) {
    this._loading = on;
    [this.minusBtn, this.plusBtn].forEach(btn => {
      if (!btn) return;
      btn.classList.toggle('btn--loading', on);
    });
    this.qtyEl?.classList.toggle('qty--syncing', on);
  }

  _shakeBtn(btn) {
    if (!btn) return;
    btn.classList.remove('shake');
    void btn.offsetWidth;
    btn.classList.add('shake');
    setTimeout(() => btn.classList.remove('shake'), 400);
  }
}

/* ══════════════════════════════════════════════════════════
   Cart Engine
   ══════════════════════════════════════════════════════════ */
const Cart = {
  data:        null,
  _queue:      Promise.resolve(),
  _controllers: new Map(),

  async init() {
    this.data = await this._fetch();
    this._refreshAllUI();
    this._bindForms();
  },

  async _fetch() {
    const r = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    const d = await r.json();
    this.data = d;
    return d;
  },

  async addItem(variantId, qty = 1, btnEl = null) {
    if (btnEl) { btnEl.classList.add('loading'); btnEl.disabled = true; }
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      const d = await r.json();
      if (!r.ok) {
        const msg = d.description || d.message || '';
        if (/stock|available|quantity/i.test(msg)) {
          Toast.show('Quantité demandée non disponible en stock.', 'err');
        } else {
          Toast.show(msg || 'Impossible d\'ajouter au panier.', 'err');
        }
        return null;
      }
      Toast.show('Produit ajouté au panier ✓', 'ok');
      await this._fetch();
      this._refreshAllUI();
      if (window.LB?.CartDrawer) CartDrawer.open();
      return d;
    } catch (e) {
      Toast.show('Erreur réseau. Réessayez.', 'err');
      return null;
    } finally {
      // Re-enable le bouton uniquement si ProductPage ne le gère pas
      if (btnEl && !window.ProductPage) {
        btnEl.classList.remove('loading');
        btnEl.disabled = false;
      } else if (btnEl) {
        btnEl.classList.remove('loading');
        // ProductPage gère disabled via _updateVariant — on ne le force pas
      }
    }
  },

  getController(key, { initialQty, maxQty, qtyEl, minusBtn, plusBtn }) {
    if (!this._controllers.has(key)) {
      const ctrl = new QtyController({
        key, initialQty, maxQty, qtyEl, minusBtn, plusBtn,
        onCommit:  (k, q) => this._enqueue(k, q, qtyEl),
        onRemove:  ()     => this._animateRemove(qtyEl)
      });
      this._controllers.set(key, ctrl);
    }
    return this._controllers.get(key);
  },

  _enqueue(key, qty, qtyEl) {
    return new Promise((resolve, reject) => {
      this._queue = this._queue
        .then(() => this._doChange(key, qty, qtyEl))
        .then(resolve)
        .catch(reject);
    });
  },

  async _doChange(key, qty, qtyEl) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const d = await r.json();

      if (!r.ok) {
        const msg  = d.description || d.message || '';
        const ctrl = this._controllers.get(key);
        if (/stock|available|quantity/i.test(msg)) {
          const realMax = d.remaining_qty ?? ctrl?.confirmedQty ?? 0;
          Toast.show(
            realMax > 0
              ? `Stock insuffisant — maximum disponible : ${realMax}`
              : 'Ce produit n\'est plus disponible.',
            'err'
          );
        } else {
          Toast.show(msg || 'Erreur mise à jour panier.', 'err');
        }
        ctrl?.revert();
        await this._fetch();
        this._refreshAllUI();
        return;
      }

      this.data = d;
      const ctrl = this._controllers.get(key);
      if (ctrl) {
        const serverItem = d.items.find(i => i.key === key);
        if (serverItem) {
          ctrl.updateConfirmed(serverItem.quantity, serverItem.variant?.inventory_quantity || 99);
        } else if (qty === 0) {
          this._animateRemove(qtyEl);
        }
      }
      this._refreshAllUI();
    } catch (e) {
      Toast.show('Erreur réseau.', 'err');
      this._controllers.get(key)?.revert();
      await this._fetch();
      this._refreshAllUI();
    }
  },

  _animateRemove(qtyEl) {
    const row = qtyEl?.closest('[data-cart-item], [data-cd-item]');
    if (!row) return;
    row.style.transition = 'opacity .3s ease, max-height .4s ease, margin .4s ease';
    row.style.overflow   = 'hidden';
    row.style.maxHeight  = row.offsetHeight + 'px';
    row.style.opacity    = '0';
    requestAnimationFrame(() => {
      row.style.maxHeight  = '0';
      row.style.marginTop  = '0';
      row.style.marginBottom = '0';
    });
    setTimeout(() => row.remove(), 450);
  },

  _refreshAllUI() {
    const c = this.data;
    if (!c) return;
    this._updateCount(c.item_count);
    this._updateSubtotals(c.total_price);
    this._updateShippingBar(c.total_price);
    if (typeof CartDrawer !== 'undefined') CartDrawer.renderItems(c);
    if (typeof CartPage   !== 'undefined') CartPage.renderItems(c);
  },

  _updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.classList.toggle('d-none', n === 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      if (n > 0) el.classList.add('bump');
    });
  },

  _updateSubtotals(cents) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      el.textContent = formatMoney(cents);
    });
  },

  _updateShippingBar(total) {
    const thresh    = window.LB?.freeShipThreshold || 4900;
    const pct       = Math.min(100, Math.round((total / thresh) * 100));
    const remaining = Math.max(0, thresh - total);
    document.querySelectorAll('[data-ship-fill]').forEach(el => el.style.width = pct + '%');
    document.querySelectorAll('[data-ship-txt]').forEach(el => {
      el.innerHTML = pct >= 100
        ? '🎉 Livraison offerte !'
        : `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte`;
    });
  },

  /* ── PATCH : ne bind que les formulaires NON-produit ───────
     Les formulaires [data-prod-form] sur la page produit sont
     déjà gérés par lb-product.js via capture:true sur submit.
     On les exclut ici pour éviter le double-binding.
  ─────────────────────────────────────────────────────────── */
  _bindForms() {
    document.querySelectorAll('[data-prod-form]').forEach(form => {
      // Si lb-product.js est présent et gère déjà ce form → skip
      // (lb-product.js utilise capture:true donc passe en premier)
      // On bind quand même pour les pages sans lb-product.js (ex: quick-add)
      if (document.querySelector('[data-variants-json]')) return;

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const variantId = parseInt(form.querySelector('[name="id"]')?.value);
        const qty       = parseInt(form.querySelector('[data-qty-input]')?.value || '1');
        const btn       = form.querySelector('[data-atc-btn]');
        if (!variantId) return;
        await Cart.addItem(variantId, qty, btn);
      });
    });
  }
};

/* ══════════════════════════════════════════════════════════
   CartPage — Page /cart
   ══════════════════════════════════════════════════════════ */
const CartPage = {
  el: null,

  init() {
    this.el = document.querySelector('[data-cart-page]');
    if (!this.el) return;
    this._bindEvents();
  },

  _bindEvents() {
    this.el.addEventListener('click', e => {
      const qtyBtn = e.target.closest('[data-qty-btn]');
      if (qtyBtn) {
        const row = qtyBtn.closest('[data-cart-item]');
        if (!row) return;
        const ctrl = this._getCtrl(row);
        if (ctrl) ctrl.step(qtyBtn.dataset.qtyBtn);
        return;
      }
      const rmBtn = e.target.closest('[data-remove-item]');
      if (rmBtn) {
        const row = rmBtn.closest('[data-cart-item]');
        if (!row) return;
        const ctrl = this._getCtrl(row);
        if (ctrl) ctrl.setTo(0);
      }
    });
  },

  _getCtrl(row) {
    const key      = row.dataset.key;
    const maxQty   = parseInt(row.dataset.maxQty || '99');
    const qtyEl    = row.querySelector('[data-qty-val]');
    const minusBtn = row.querySelector('[data-qty-btn="minus"]');
    const plusBtn  = row.querySelector('[data-qty-btn="plus"]');
    const initQty  = parseInt(qtyEl?.dataset.qty || '1');
    if (!key) return null;
    return Cart.getController(key, { initialQty: initQty, maxQty, qtyEl, minusBtn, plusBtn });
  },

  renderItems(cart) {
    if (!this.el) return;
    cart.items.forEach(item => {
      const row = this.el.querySelector(`[data-cart-item][data-key="${item.key}"]`);
      if (!row) return;
      const priceEl = row.querySelector('[data-line-price]');
      if (priceEl) priceEl.textContent = formatMoney(item.line_price);
      const ctrl = Cart._controllers.get(item.key);
      if (ctrl) ctrl.updateConfirmed(item.quantity, item.variant?.inventory_quantity || 99);
    });
    document.querySelectorAll('[data-cart-total]').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
  }
};

/* ── Init ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  Toast.init();
  Cart.init();
  CartPage.init();
});

window.LB = window.LB || {};
window.LB.Cart        = Cart;
window.LB.Toast       = Toast;
window.LB.formatMoney = formatMoney;